import { instance } from "apis/interceptor";
import { TMember } from "types/user.types";

type ResponseType<T> = {
  success: boolean;
  message?: string;
  statusCode?: number;
  data?: T;
};

//FEAT: (new) 내 멤버 정보 조회
export const getMyMemberinfo = async (): Promise<ResponseType<TMember>> => {
  try {
    const res = await instance.get("/members/my/info");

    return { success: true, data: res.data};
  } catch (error: any) {
    return { success: false, message: "처리 중 오류가 발생했습니다." };
  }
};

//FEAT: (new) 내 멤버 정보 수정
export const updateMyMemberInfo = async (
  nickname?: string,
  image?: string,
): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/members/my/info", {
      nickname: nickname ?? "",
      image: image ?? "",
    });

    return { success: res.data.result };
  } catch (error: any) {
    const statusCode = error.response.status;
    if (statusCode === 403) {
      return { success: false, message: "수정 권한이 없습니다. 권한을 확인해주세요." };
    } else {
      return { success: false, message: "내 정보 수정에 실패했습니다. 다시 시도해주세요." };
    }
  }
};
